import React from "react";

import {
  EmailTable,
  EmailAnalysisText,
  EmailUl,
  EmailLi,
  DangerousTd,
  EmailExpireText
} from "../styles";
import { generateButtonHtml } from "../constants";

const PrepaymentTemplate = ({ _primaryColor, secondaryColor }) => (
  <EmailTable>
    <tr>
      <EmailAnalysisText style={{ color: `#${secondaryColor}` }}>
        Analysis at your fingertips
      </EmailAnalysisText>
    </tr>
    <tr>
      <EmailUl>
        <EmailLi>Prepayment Penalty</EmailLi>
        <EmailLi>Prepayment Projections</EmailLi>
        <EmailLi>Prepayment Schedule</EmailLi>
      </EmailUl>
    </tr>
    <tr>
      <DangerousTd dangerouslySetInnerHTML={generateButtonHtml(secondaryColor)} />
    </tr>
    <tr>
      <td>
        <EmailExpireText>
          {"(This link will expire in 30 days.)"}
        </EmailExpireText>
      </td>
    </tr>
  </EmailTable>
);

export default PrepaymentTemplate;
